// extracted by mini-css-extract-plugin
export var attachment = "_s9-a";
export var emailContainer = "_s9-4";
export var emailContentPaddedContainer = "_s9-b";
export var emailHeader = "_s9-6";
export var emailIframe = "_s9-3";
export var emailInfoIcon = "_s9-9";
export var emailShortenedSummary = "_s9-e";
export var infoDropdown = "_s9-0";
export var infoRowBoundedContent = "_s9-d";
export var internal = "_s9-5";
export var merchant = "_s9-8";
export var messageInputContainer = "_s9-h";
export var normal = "_s9-7";
export var replyCard = "_s9-f";
export var subtleButton = "_s9-1";
export var subtleButtonIconContainer = "_s9-2";
export var toggleViewRepliesButton = "_s9-c";
export var wrappingText = "_s9-g";